import {postMethod} from '~/api'

async function post(body) {
    return await postMethod('/api/manualModification', body)
}

export {post}
